<button class="ui button" (click)="setValue(option)" [class.active]="isActive(option)" [class.image-button]="option.image || option.color" [ngClass]="option.class" [disabled]="disabled" *ngFor="let option of options" type="button">
  <img *ngIf="option.image" [src]="option.image" [style.backgroundColor]="option.color" class="image">
  <div *ngIf="option.color && !option.image" class="image" [style.backgroundColor]="option.color"></div>
  <i *ngIf="option.icon" [ngClass]="option.icon" class="icon"></i>
  <div class="label">{{option.name}}</div>
</button>
